import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private static readonly BASE_URL: string = `analytics/admin-dashboard`;

  constructor(private _apiService: ApiService) {}

  getDashboardData(
    shopId: number,
    range: {
      startDateValue: number | string;
      endDateValue: number | string;
    },
  ) {
    return this._apiService.get(`${DashboardService.BASE_URL}/data/${shopId}`, {
      params: {
        start: `${range.startDateValue}`,
        end: `${range.endDateValue}`,
      },
    });
  }

  getDashboardDataV2(
    shopId: number,
    range: {
      startDateValue: number | string;
      endDateValue: number | string;
    },
  ) {
    return this._apiService.get(`${DashboardService.BASE_URL}/datav2/${shopId}`, {
      params: {
        start: `${range.startDateValue}`,
        end: `${range.endDateValue}`,
      },
    });
  }

  updateDashboardSettings(shopId: number, settings: any) {
    return this._apiService.post(`${DashboardService.BASE_URL}/settings/${shopId}`, settings);
  }
}
